import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';
import { decamelize } from '../../../utils/keysConverter';

export default {
  update(params) {
    const url = formUrl(`/api/v1/admin/offers/reorder_offers_by_store`);

    return FetchHelpers.post(url, params);
  },
};
